export const HOME_FAQS = [
  {
    q: "What are fractional HR services?",
    a: "Fractional HR services put a senior HR leader on your team on a part-time or interim basis — typically 2 to 3 days a week — to bring senior HR judgment to founders and boards without the cost or commitment of a full-time executive hire. Orphion offers advisory, embedded and interim fractional HR engagements from Bengaluru, working globally.",
  },
  {
    q: "How is Orphion different from a traditional recruitment agency?",
    a: "Orphion is a boutique practice combining recruitment with HR strategy, operations, employer branding and fractional HR leadership. Traditional agencies close roles; Orphion also helps you design the roles, the pay structure, the induction and the culture that makes those roles stick.",
  },
  {
    q: "Which industries do you recruit for?",
    a: "Two segments only, by design: Global Capability Centres (GCCs) being built or scaled in India, and AI-native IT services and product companies (typically 50–1,500 employees). Narrow focus is what keeps our shortlists calibrated.",
  },
  {
    q: "Where is Orphion based and which regions do you serve?",
    a: "Orphion is headquartered in Bengaluru, India. Compensation and policy work is delivered across the United States, United Kingdom, Canada, India, Poland, Spain and Ukraine.",
  },
  {
    q: "How quickly can we start an engagement?",
    a: "Discovery call within 1 business day of your enquiry. A scoped proposal (scope, timeline, price) inside the same business day. Most fractional HR engagements begin within 2-3 weeks; single-role recruitment mandates start immediately after alignment.",
  },
  {
    q: "How do I get in touch?",
    a: "Fill the enquiry form at /contact. We reply within one business day with a proposal shape. There is no cold email list — every conversation starts from the form.",
  },
];

export const SERVICES_FAQS = [
  {
    q: "Can I engage a single practice, or do I need the full package?",
    a: "Each of the five practices — Recruitment, HR Consulting, HR Operations, Employer Branding and GCC Support — is a stand-alone engagement. Fractional HR services sit within HR Consulting. Most clients start with one and add others under a fractional arrangement as needs evolve.",
  },
  {
    q: "What roles does Orphion recruit for?",
    a: "Product, engineering, data, ML, DevOps, sales, marketing, operations, and executive/leadership roles — for Global Capability Centres and AI-native IT services and product companies. Both permanent and contract, across seniority.",
  },
  {
    q: "Do you handle multi-country compensation and policy work?",
    a: "Yes. We have delivered comp and policy work across the US, UK, Canada, India, Poland, Spain and Ukraine — from statutory guardrails to competitive band architecture, ESOP and LTI design.",
  },
  {
    q: "What does a fractional HR engagement typically look like?",
    a: "Three formats: Advisory (a trusted voice for founders and boards on org and people risk), Embedded (2-3 days a week inside your leadership team), or Interim (steady the ship during fundraise, M&A or CHRO transition).",
  },
  {
    q: "How is pricing structured?",
    a: "Recruitment mandates are typically a percentage of first-year CTC, invoiced on join. Fractional HR and consulting engagements are scoped as fixed monthly retainers. We share a written proposal with scope, timeline and price within one business day of the discovery call.",
  },
];

export const JOBS_FAQS = [
  {
    q: "How often do you post new roles?",
    a: "New roles for GCCs and AI-native IT companies are added regularly. Save a search (Save this search on the /jobs sidebar) and we will email you the moment a matching role opens.",
  },
  {
    q: "What happens after I apply?",
    a: "Every application is reviewed by a senior recruiter. If your profile matches, we schedule a 30-minute conversation to understand your goals and calibrate the role, before introducing you to the hiring team.",
  },
  {
    q: "Can I apply without a CV?",
    a: "Yes — you can fill the /apply form directly. But dropping a CV lets our AI pre-fill your profile, including skills, LinkedIn, GitHub and years of experience, in a few seconds. Faster for you, faster for us.",
  },
];
